<div class="watchFace">
  <div class="medal">
    <div class="ribbonRight"  [class]="type?.toLowerCase()"></div>
    <div class="ribbonLeft"  [class]="type?.toLowerCase()"></div>
    <div class="star" [class]="type?.toLowerCase()">
      <ion-icon name="star"></ion-icon>
    </div>
  </div>
  {{ achievement.rank === 2 ? '2nd ' : achievement.rank === 3 ?'3d': ''}}Fastest {{achievement.name}}!
  <br>
  <span>{{achievement.moving_time | elapsed}}</span>
</div>
